import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BudgetPlanner from "@/components/BudgetPlanner";

function App() {
  return (
    <div className="App grain-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BudgetPlanner />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
